import { render } from "./DesktopMenu.vue?vue&type=template&id=5d53b54a&scoped=true"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"

import "./DesktopMenu.vue?vue&type=style&index=0&id=5d53b54a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d53b54a"
/* hot reload */
if (module.hot) {
  script.__hmrId = "5d53b54a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d53b54a', script)) {
    api.reload('5d53b54a', script)
  }
  
  module.hot.accept("./DesktopMenu.vue?vue&type=template&id=5d53b54a&scoped=true", () => {
    api.rerender('5d53b54a', render)
  })

}

script.__file = "src/components/menu/DesktopMenu.vue"

export default script